import { render, staticRenderFns } from "./LinkCardCred.vue?vue&type=template&id=3e630c7d"
import script from "./LinkCardCred.vue?vue&type=script&lang=js"
export * from "./LinkCardCred.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports